import { investorApiClient } from 'api';
import {
  InvestorApiControllerGetMarketAllocationStatisticsParams,
  InvestorApiControllerGetMarketOverviewStatisticsParams,
  MarketAllocationResultDto,
  MarketOverviewListedOriginatorsResultDto,
  MarketOverviewStatisticsResultDto,
} from 'api/investor-client';

type ApiResponse<T> = Promise<{ data: T }>;

export interface MarketOverviewDataSource {
  getMarketOverviewStatistics(
    query: InvestorApiControllerGetMarketOverviewStatisticsParams,
  ): ApiResponse<MarketOverviewStatisticsResultDto>;
  getMarketOverviewListedOriginators(): ApiResponse<MarketOverviewListedOriginatorsResultDto>;
  getMarketAllocationStatistics(
    query: InvestorApiControllerGetMarketAllocationStatisticsParams,
  ): ApiResponse<MarketAllocationResultDto>;
}

export const investorMarketOverviewDataSource: MarketOverviewDataSource = {
  getMarketOverviewStatistics: (query) =>
    investorApiClient.investors.investorApiControllerGetMarketOverviewStatistics(query),
  getMarketOverviewListedOriginators: () =>
    investorApiClient.investors.investorApiControllerGetMarketOverviewListedOriginators(),
  getMarketAllocationStatistics: (query) =>
    investorApiClient.investors.investorApiControllerGetMarketAllocationStatistics(query),
};

export const publicMarketOverviewDataSource: MarketOverviewDataSource = {
  getMarketOverviewStatistics: (query) =>
    investorApiClient.publicInvestors.publicInvestorApiControllerGetPublicMarketOverview(query),
  getMarketOverviewListedOriginators: () =>
    investorApiClient.publicInvestors.publicInvestorApiControllerGetPublicMarketOverviewListedOriginators(),
  getMarketAllocationStatistics: (query) =>
    investorApiClient.publicInvestors.publicInvestorApiControllerGetPublicMarketAllocation(query),
};
